<template>
  <div class="flex flex-col w-full pt-4 px-1 min-h-screen space-y-6">
    <div>
      <h2
        class="text-base sm:text-lg text-center lg:text-left font-semibold text-gray-900"
      >
        Customer Usage History
      </h2>
    </div>
    <form
      class="flex flex-col space-y-4 xl:space-y-0 xl:flex-row xl:items-center xl:space-x-5 mt-3"
    >
      <div class="rounded-lg border w-full lg:w-3/5 border-gray-200">
        <input
          type="text"
          class="w-full px-4 py-2 border-0 rounded-lg outline-none text-sm focus:border-express"
          v-model.trim="mac"
          placeholder="Search using mac id"
        />
      </div>

      <div class="flex flex-col sm:flex-row gap-3">
        <div class="flex space-x-2 items-center">
          <label class="text-sm text-expressgray whitespace-nowrap" for="start"
            >Start Date:</label
          >
          <input
            type="date"
            v-model="startDate"
            id="start"
            class="border border-gray-200 rounded-lg p-1.5 text-sm focus:outline-none focus:border-express"
          />
        </div>

        <div class="flex space-x-2 items-center">
          <label class="text-sm text-expressgray whitespace-nowrap" for="end"
            >End Date:</label
          >
          <input
            type="date"
            v-model="endDate"
            id="end"
            class="border border-gray-200 rounded-lg p-1.5 text-sm focus:outline-none focus:border-express"
          />
        </div>
      </div>

      <input
        type="submit"
        value="Search"
        @click.prevent="getUsageHistory"
        class="h-10 w-full xl:w-40 rounded-lg bg-express text-white text-sm font-medium hover:bg-expressbutton cursor-pointer transition-colors"
      />
    </form>

    <div
      v-if="!isLoading"
      class="flex flex-col bg-white border border-gray-100 rounded-lg shadow-sm w-full text-expressgray mb-5 h-full"
    >
      <div class="w-full overflow-x-auto">
        <table class="w-full text-sm">
          <tr class="border-b border-gray-200 text-center bg-gray-50">
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Mac</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Upload (mb)</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">Download (mb)</th>
            <th class="px-3 py-3 font-semibold text-expressgray whitespace-nowrap">date</th>
          </tr>
          <tbody v-if="customer_usage_List.length > 0">
            <tr
              class="border-b border-gray-100 text-center hover:bg-gray-50"
              v-for="(item, index) in customer_usage_List"
              :key="index"
            >
              <td class="px-3 py-3 whitespace-nowrap">{{ item.username }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.upload_mb }}</td>
              <td class="px-3 py-3 whitespace-nowrap capitalize">{{ item.download_mb }}</td>
              <td class="px-3 py-3 whitespace-nowrap">{{ item.startDate }}</td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <p class="whitespace-nowrap font-semibold text-sm ml-2">
                No data available
              </p>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-5 mx-5" v-else>
      <loading message="Loading, please wait"></loading>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useToast } from "vue-toast-notification";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { isValidMACAddress } from "@/utils/globalFunctions.js";

const store = useStore();
const $toast = useToast();
const $router = useRouter();

const mac = ref(null);
const startDate = ref(new Date().toISOString().split("T")[0]);
const endDate = ref(new Date().toISOString().split("T")[0]);
const isLoading = ref(false);

const customer_usage_List = computed(
  () => store.getters["admins/customer_usage_list"]
);

async function getUsageHistory() {
  if (!isValidMACAddress(mac.value)) {
    $toast.error("Please provide valid Mac ID", {
      position: "top-right",
      duration: 4500,
    });
    return;
  }

  isLoading.value = true;
  await store.dispatch("admins/get_customer_usage_history", {
    mac: mac.value,
    startdate: startDate.value,
    enddate: endDate.value,
    toast: $toast,
    router: $router,
  });
  isLoading.value = false;
}
</script>
